import { DatePipe } from "@angular/common";
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import { CostService } from "../../../services/index";
import * as fromRootStore from "../../../reducers";
import { ComboService, SampleService, WorkOrderService } from "../../../services/index";

@Component({
  selector: "AddeditExistSetBagging",
  templateUrl: "./AddeditExistSetBagging.html",
})
export class AddeditExistSetBagging {
  auto_number: number;
  season_name: string;
  row: any;
  data: any;
  temp: any = {
    set: '',
    id: 0,
  };
@ViewChild('shirtBarcodeInput') shirtBarcodeInput: ElementRef;
designPreview : any = [];
  bag_data: any = {

  }
  sizeRes = [];
  count: number = 0;
  scannedDes_id: number = 0;
  totPcs: number = 0;
  hsTot: number = 0;
  qualityList: any;
  typeList: any;
  coreList: any;
  shadeIndex: number = 0;
  onsaveDisable: boolean = true;
  gangList: any;
  coredesignList: any;
  gangdesignList: any;
  shadeTypeList: any = [];
    fullsetData: any[];
  halfsetData: any[];
  combinedSet: any[];
  setFull: any;
   setHalf: any;
  sizeList: any;
  materialList: any;
  matList: any;
  shadeTypeListExists: any = [];
  purchaseAgentList = [];
  seasonList = [];
  designColors: any = [];
  setMasterList: any = [];
  GroupList: any = [];
  detailList: any = [];
  categoryData: any = [];
  saveDetect: boolean = false
  filter: any = {
    season: "",
    date: "",
    ref_no: "",
    combo_name: "",
    shirt_no: "",
    bag_barcode: "",
    combo_set_name: "",
    sleeve: "",
    set_name: "",
    set_id: 0,
    // dhoti_no: "",
    // style: "",
    // variety: "",
    // dp_shirt: 0,
    // dp_dhoti: 0,
    // margin: 0,
    // combo_mrp: 0,
    // fs_rate: 0,
    // hs_rate: 0,
    // category: ""
  };

  designnoList = [];

  stockData = [];
  hsetData = [];
  des = {
    style : '',
    variety: '',
    design: '',
    material: '',
    pref: ''
  }
  shirtBarcodeDetails = [];

  comboDetails = [];
  barcodeDisabled = false;


  shadeType = "";
  shadeColor = "";
  widthList: any[];
  // designTypeList = ["NEW", "CORE", "GANG"];
  // desData: any = {
  //   totalmtr: 0,
  //   totalamt: 0,
  // };
  mode: string;
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    // this.saveEvent = val["data"].tabevent;
    // let designdata = Object.assign({}, val["data"]);

    // if (this.mode == "Edit" || this.mode == "View") {
    //   this.filter = designdata;
    //   this.filter.date = designdata.ref_date;
    //   this.setMainDetails(this.filter)
    //   this.getComboStockDetails();
    // }
  }

  get params(): any[] {
    return this._params;
  }



  tempData = [];

  @Output() tabUpdateEvent = new EventEmitter();
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  filteredOptions: Observable<string[]>;
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private costservice: CostService,
    private sampService: SampleService,
    private workOrderservice: WorkOrderService,
    private comboservice: ComboService,
  ) {
    (window as any)["comp"] = this;
  }
  ngOnInit() {

    this.filter.date = this.datePipe.transform(new Date(), "yyyy-MM-dd");

    this.tableScroll();
    this.getSetDetails();
    this.getcolorGroup();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#date").focus();
    }, 100);
  }
  tableScroll() {
    $(".purreturn").height(window.innerHeight - 60);
    $(".pobody").width(window.innerWidth - 30);
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getSetDetails() {

    let params = {
      page_type: 'Opening Set',
    }

    this.workOrderservice.getSetDetails(params).then((res: any) => {
      this.setMasterList = res.data

    });
  }

  getcolorGroup() {
    let params = {
      page_type: 'Color Group',
    }

    this.workOrderservice.getSetDetails(params).then((res: any) => {
      this.GroupList = res.data
    
    });
  }

  changeCheckbox(event: any){

  if (this.count > 0) {

     this.filter.sizeChecked = false;
     event.source.checked = false;
     swal("ERROR", `Bagging Process Pending, Can't Change !!`, "error");
    // setTimeout(() => {
    //   this.filter.sizeChecked = false;
    // },1000);
   
  }
  else {
    this.temp = {};
    this.sizeRes = [];
    this.filter.bag_barcode = '';
    
    this.scannedDes_id = 0;
     this.filter.set_name = '';
     this.filter.combo_set_name = '';
     this.des.material = '';
     this.filter.set_id = 0;
     this.filter.sleeve = '';
  }


}

  getDesignopenStk() {

    // if (isNaN(this.filter.design_no)) {
    //   swal("ERROR", `It's a Plain SDesign Not Allowed!!`, "error")
    // }
    this.filter.design_type = '';
       this.totPcs = 0;
       this.stockData = [];
       this.shirtBarcodeDetails = [];
      let params = {
        design_no: this.filter.design_no,
      }

      this.sampService.getDesignopenStk(params).then((res: any) => {

        if (res.needsReset) {
          swal({
            title: 'Reset Required',
            text: `This design has ${res.resetCount} piece(s) marked as completed via RGRN (without opening stock scan). These must be reset before proceeding.\n\nIMPORTANT: If you start and do not complete opening stock for all pieces, you must revert before exiting. Partial re-entry is not allowed.`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Reset & Proceed',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#d33',
          }).then(() => {
            this.sampService.resetOpeningStock({ design_no: this.filter.design_no }).then((resetRes: any) => {
              if (resetRes.success) {
                swal('Reset Done', `${resetRes.resetCount} piece(s) reset. You can now proceed with opening stock.`, 'success');
                this.getDesignopenStk();
              } else {
                swal('ERROR', resetRes.message || 'Reset failed', 'error');
              }
            });
          }).catch(() => {
            this.filter.design_no = '';
          });
          return;
        }

        if (res.data && res.data.length > 0) {
          this.stockData = res.data;
          this.des = res.desRes;
          this.matList = res.materialList;
          this.filter.design_no = res.desRes.design;
          this.filter.sizeChecked = (res.data[0].design_type == 'NEW' || res.data[0].design_type == 'PLAIN') ? false : true
          this.filter.design_type = res.data[0].design_type;
          this.combinedSet = res.combinedSet;
           this.totPcs = this.stockData.reduce((sum, e) => sum + (Number(e.stk_tot) || 0), 0);

          if(!this.filter.sizeChecked && res.combinedSet && res.combinedSet.length == 0){

            this.checksetData();
          }
          }
        else if(!res.success){
          swal("ERROR", `${res.message}`, "error")
        }
        //Scanned List
        if(res.barcodeList && res.barcodeList.length > 0){
            this.shirtBarcodeDetails = res.barcodeList
        }
        this.checkSave();

        // this.barcodeFocus('combo_set_name')
      });
    

  }
  setMasterDet() {

    let obj = this.setMasterList.find(e => e.sleeve_combo == this.filter.combo_set_name);
    this.filter.sleeve = obj.sleeve;
    this.filter.set_name = obj.set_combo;
    this.filter.set_id = obj.id;
    this.sizeRes = [];
    this.temp.set = this.filter.set_name;
    // this.temp.id = res.data.set_id;
    const [start, end] = this.temp.set.split("-").map(Number);


    for (let i = start; i <= end; i++) {
      if (i % 2 === 0) {
        this.sizeRes.push(i.toString());
      }
    }
    //For Get mataril Count
    if (this.sizeRes.length > 0) {
      let obj = this.matList.find(e => e.capacity == this.sizeRes.length)
       this.des.material = obj.material
      this.des.pref = obj.prefix
    }
 

  }



  

 checksetData() {

    let rgrnData = [];

    function getSleevData(setSize, rowSize, deletSize, setName, Data, setMaster) {

      rgrnData = JSON.parse(JSON.stringify(Data));
      let filteredSets = setMaster
        .filter(set => set.sleeve === `${setSize}`)
        .sort((a: any, b: any) => a.priority - b.priority);

      let result = [];
      for (let i = 0; i < rgrnData.length; i++) {
        for (let size = 36; size <= 46; size += 2) {
          delete rgrnData[i][`${deletSize}${size}`];
        }
        delete rgrnData[i][`${deletSize}tot`];
      }
      rgrnData.forEach((item: any) => {
        let remainingItem = { ...item };

        filteredSets.forEach(set => {
          let sizes = set.set_combo.split('-').map(Number);
          let minQty = Infinity;

          // Find the minimum quantity among the sizes in the set
          for (let size = sizes[0]; size <= sizes[1]; size += 2) {
            if (remainingItem[`${rowSize}${size}`] < minQty) {
              minQty = remainingItem[`${rowSize}${size}`];
            }
          }

          if (minQty > 0) {
            // let newItem = { ...remainingItem };
            let newItem = {};
            for (let size = sizes[0]; size <= sizes[1]; size += 2) {
              newItem[`${rowSize}${size}`] = minQty;
              remainingItem[`${rowSize}${size}`] -= minQty;
            }
            // Set remaining sizes (not part of the set) to zero
            for (let size = 36; size <= 46; size += 2) {
              if (size < sizes[0] || size > sizes[1]) {
                newItem[`${rowSize}${size}`] = 0;
              }
            }
            newItem['shade'] = remainingItem.stk_color;
            newItem['design_id'] = remainingItem.design_id;
            newItem[`${rowSize}tot`] = minQty * ((sizes[1] - sizes[0]) / 2 + 1);
            newItem[`${setName}_name`] = set.set_combo;
            newItem[`${setName}_id`] = set.id;
             newItem[`set_id`] = set.id;
            newItem[`${setName}_count`] = minQty;
            //Ui Data View Purpose
            newItem[`${setName}_size`] = set.set_combo;
            newItem[`${setName}_sizeQty`] = minQty;
            result.push(newItem);
          }
        });

        // Push remaining quantities
        for (let size = 36; size <= 46; size += 2) {
          if (remainingItem[`${rowSize}${size}`] > 0) {
            let newItem = {};
            newItem['shade'] = remainingItem.stk_color;
            newItem['design_id'] = remainingItem.design_id;
            newItem[`${rowSize}${size}`] = remainingItem[`${rowSize}${size}`];
            newItem[`${rowSize}tot`] = remainingItem[`${rowSize}${size}`];
            newItem[`${setName}_name`] = '';
              newItem[`${setName}_id`] = '';
             newItem[`set_id`] = '';
            newItem[`${setName}_count`] = 0;
            //Ui Data View Purpose
            newItem[`${setName}_size`] = `${size} SIZE`;
            newItem[`${setName}_sizeQty`] = remainingItem[`${rowSize}${size}`];
            // Set all other sizes to zero
            for (let otherSize = 36; otherSize <= 46; otherSize += 2) {
              if (otherSize !== size) {
                newItem[`${rowSize}${otherSize}`] = 0;
              }
            }
            result.push(newItem);
            remainingItem[`${rowSize}${size}`] = 0;
          }
        }
      });
      return result
    }
    this.fullsetData = [];
    this.halfsetData = [];

    this.fullsetData = getSleevData('F/S', 'stk_f', 'stk_h', 'fullset', this.stockData, this.setMasterList)
    this.halfsetData = getSleevData('H/S', 'stk_h', 'stk_f', 'halfset', this.stockData, this.setMasterList)

    let combinedSets = [];


// Process full sets
if (Array.isArray(this.fullsetData) && this.fullsetData.length > 0) {
  const validFSet = this.fullsetData
    .filter(item => parseInt(item.set_id) > 0)
    .map(item => {
      const count = parseInt(item.fullset_count);
      const total = parseInt(item.stk_ftot);
      return {
        design_id: item.design_id,
        shade: item.shade,
        set_per: count > 0 ? total / count : 0,
        count: parseInt(item.fullset_count),
        set_type: 'F/S',
        setName: item.fullset_name,
        scanned:0
      };
    });
  combinedSets = combinedSets.concat(validFSet);
}

// Process half sets
if (Array.isArray(this.halfsetData) && this.halfsetData.length > 0) {
  const validHSet = this.halfsetData
    .filter(item => parseInt(item.set_id) > 0)
    .map(item => {
      const count = parseInt(item.halfset_count);
      const total = parseInt(item.stk_htot);
      return {
        design_id: item.design_id,
        shade: item.shade,
        set_per: count > 0 ? total / count : 0,
         count: parseInt(item.halfset_count),
          set_type: 'H/S',
          setName: item.halfset_name,
         scanned: 0
      };
    });
  combinedSets = combinedSets.concat(validHSet);
}

   combinedSets.forEach(entry => {
            const matchedMaterial = this.matList.find(mat => mat.capacity === entry.set_per);
            if (matchedMaterial) {
              entry.item = matchedMaterial.prefix;
            }
            entry.bal = entry.count - entry.scanned;
          });
  this.combinedSet = combinedSets
this.combinedSet.sort((a, b) => {
  // First, compare by shade (ascending)
  if (a.shade < b.shade) return -1;
  if (a.shade > b.shade) return 1;

  // If shades are equal, compare set_per (descending)
  return b.set_per - a.set_per;
});


}


  

  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSeason(params).then((res: any) => {
      let partialSeason = [];

      for (let i = res.length - 1; i > res.length - 10; i--) {
        partialSeason.push(res[i]);
      }

      let today = new Date();
      let curDate =
        today.getFullYear() +
        "-0" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();

      res.forEach((el) => {
        if (curDate >= el.order_from && curDate <= el.order_to) {
          this.filter.season = el.season;
        }
      });

      this.seasonList = partialSeason;
    });
  }



  checkSave() {

    this.onsaveDisable = true;

    //For Handling Save Flag
    //For Size
    if(this.filter.sizeChecked){
     this.onsaveDisable = false;
    }
    //For set
    else if (this.shirtBarcodeDetails.length && !this.count && this.sizeRes && this.shirtBarcodeDetails
      .filter(e => e.isBackground == true).length == 0) {
      this.onsaveDisable = false;
    }


  }

  getBagBarcodeDetails(flag: string, event: any) {

    if(this.des.pref !== this.filter.bag_barcode.split('-')[0]){
      this.filter.bag_barcode = "";
      swal("ERROR", `Pls Scan ${this.des.pref} Material`, "error")

      // this.barcodeFocus('bag_barcode');
      return false
    }
    const params = {
      bag_barcode: this.filter.bag_barcode,
    }
   

    if (this.filter.bag_barcode.length != 8) {

   

      const [prefix, number] = this.filter.bag_barcode.split('-');

      const requiredLength = 8;
      const dashLength = 1;
      const prefixLength = prefix.length;
      const paddedNumberLength = requiredLength - prefixLength - dashLength;

      // Pad the number with leading zeros
      const paddedNumber = number.padStart(paddedNumberLength, '0');

      // Final barcode
      this.filter.bag_barcode = `${prefix}-${paddedNumber}`;


    }


      // Split into prefix and padded number
      let [prefix, paddedNumber] = params.bag_barcode.split('-');

      // Remove leading zeros
      let originalNumber = paddedNumber.replace(/^0+/, '');

      // Handle case like 'B3-000000' → 'B3-0'
      if (originalNumber === '') {
        originalNumber = '0';
      }

      // Combine back to short format
      let shortCode = `${prefix}-${originalNumber}`;

      const isExist = this.shirtBarcodeDetails.find((data) => data.bag_barcode == shortCode);
      if (!isExist) {

        this.sampService.getShirtbarcodeDet(params).then((res: any) => {
          if (res.success && res.bagData) {

            this.bag_data = res.bagData
           this.filter.bag_barcode = this.bag_data.bag_barcode;

            this.barcodeFocus('shirtBarcode');
          } else {
            this.errorSwal(res.message);
            this.filter.bag_barcode = '';
            this.barcodeFocus('bag_barcode');
          }


        });
      } else {
        this.errorSwal("Bag Barcode already exist");
        this.filter.bag_barcode = '';
        this.barcodeFocus(flag);
      }
    // }

  }





  getBarcodeDetails(flag: string, event: any) {
    this.onsaveDisable = true;
    if (!this.filter.bag_barcode && !this.filter.sizeChecked) {
      this.errorSwal("Please Enter Bag.No!!");
      event.target.value = '';
      this.barcodeFocus('bag_barcode');
      return;
    }
    let setsizeExist = false;
    const params = {
      barcode: event.target.value,
      exist_items: 'Bagging',
      design_no : this.filter.design_no
    }
    if (flag == "shirtBarcode") {
      if (params.barcode.length == 7) {
        const isExist = this.shirtBarcodeDetails.find((data) => data.barcode == params.barcode);
        if (!isExist) {
          let that = this;
          that.barcodeDisabled = true;
          that.sampService.getShirtbarcodeDet(params).then((res: any) => {
            if (res.success && res.data) {




              //For set Processes
            if(!that.filter.sizeChecked) {
              res.data['bag_barcode'] = this.bag_data.bag_barcode
              res.data['bag_id'] = this.bag_data.bag_id
              res.data['set_name'] = that.filter.set_name;
              res.data['set_id'] = that.filter.set_id;
              that.scannedDes_id = !that.scannedDes_id ? res.data['design_id'] : that.scannedDes_id;
              if (!that.temp.style) {
                const rawStyle = res.data.style.toLowerCase().trim();
                if (['rr formal', 'stylish formal', 'stylishformal', 'club', 'ol-formal'].includes(rawStyle)) {
                  that.temp.style = 'formal';
                } else if (['rr casual', 'ol-casual'].includes(rawStyle)) {
                  that.temp.style = 'casual';
                } else {
                  that.temp.style = rawStyle;
                }
              }

              if (res.data.design != this.filter.design_no) {

                swal("ERROR", `${res.data.design} It's a Different Design Item!!`, "error")
              }
              else if (that.filter.sleeve && (that.filter.sleeve.charAt(0) != res.data.size.charAt(0))) {

                swal("ERROR", `It's a Different Sleeve Item!!`, "error")

              }
              else if (that.scannedDes_id && (that.scannedDes_id != res.data['design_id'])) {
                swal("ERROR", ` ${res.data.design_no}- Is Different Design/Shade Pcs!!`, "error")
              }
              else if (that.shirtBarcodeDetails.find(x => x.bag_barcode && x.size && x.bag_barcode.trim() == this.bag_data.bag_barcode && x.size.trim() == res.data.size)) {

                swal("ERROR", `${res.data.size} Already Exist this Bag!!`, "error")

              }

              else if (that.sizeRes.includes(res.data.size.split('').filter(char => !isNaN(char)).join('')) && that.filter.sleeve.charAt(0) == res.data.size.charAt(0)) {

                that.count = that.count + 1;


                //Check capacity with scanned set pcs Count
                if (that.temp.style && that.temp.style in that.bag_data) {
              
                  // key exists in bag_data
                  const value = that.bag_data[that.temp.style];

                  if (value && (that.count > value)) {

                    swal("ERROR", `Bag Capacity (${value}) Reached Can't Scan!!`, "error")
                    that.count = that.count - 1;
                    that.barcodeDisabled = false;
                    that.barcodeFocus('shirtBarcode');
                    return
                  }
                  else if (!value) {
                    swal("ERROR", `Bag Capacity Not Entered For (${that.temp.style.toUpperCase()}) Can't Scan!!`, "error")
                    that.barcodeDisabled = false;
                    that.barcodeFocus('shirtBarcode');
                    return
                  }
                }
                else {
              
                  swal("ERROR", `Bag Capacity Not Entered For (${that.temp.style.toUpperCase()}) Can't Scan!!`, "error")
                  that.barcodeDisabled = false;
                  that.barcodeFocus('shirtBarcode');
                  return
                }



                res.data['isBackground'] = that.count > 0;
                that.shirtBarcodeDetails.unshift(res.data);

                if (that.count == that.sizeRes.length) {

                     let obj = this.setMasterList.find(e => e.sleeve_combo == this.filter.combo_set_name);
 
                    this.combinedSet.forEach(item => {
                      if (
                        item.setName == obj.set_combo && item.set_type === obj.sleeve && item.design_id == that.scannedDes_id
                      ) {
                        item.scanned += 1;
                        item.bal = item.count - item.scanned;
                        item.isBackground = item.bal > 0;
                        item.isCompleted = (item.count == item.scanned)
                      }
                    });
                    
                  that.count = 0;
                  that.filter.bag_barcode = '';
                  flag = 'bag_barcode';
                  // that.des.material ='';
                  // that.des.pref = '';
                  that.scannedDes_id = 0;
                  that.temp.style = '';
                  that.shirtBarcodeDetails = that.shirtBarcodeDetails.map((item) => ({
                    ...item,
                    isBackground: false,
                  }));


                

                }
                this.updateStockWithScanned(this.stockData, res.data, 'Add')

              }
              else {
                swal("ERROR", `${res.data.size} It's a Different SIze Item!!`, "error")
              }

              that.checkSave();
            }

            //For size Item
            else if(that.filter.sizeChecked){

              if (that.filter.design_no != 'DAMAGE' && that.filter.design_no != 'OLIVE' && that.filter.design_no != 'OTHER BRANDS' && that.filter.design_no != 'SPECIAL GOODS' && (that.filter.design_no != res.data.design)) {
                swal("ERROR", `${res.data.design} It's a Different Design Item!!`, "error")
                that.barcodeDisabled = false;
                that.barcodeFocus(flag);
                return
              }
              that.shirtBarcodeDetails.unshift(res.data);
              that.reOrdStockData(res.data);
    
              that.checkSave();
            }
            } else {
              that.errorSwal(res.message);
                   that.checkSave();
            }
            that.barcodeDisabled = false;
            that.barcodeFocus(flag);
        
          });

        } else {
          this.errorSwal("Barcode already exist");
          this.checkSave();
        }
        event.target.value = "";
      }
    }
  }

  errorSwal(message: string) {
    swal({
      type: "error",
      titleText: message,
      showCancelButton: false,
      showConfirmButton: false,
      timer: 2000
    });
  }

reOrdStockData(data){

  this.stockData.sort((a, b) => {
  return (b.design_no === data.design ? 1 : 0) - (a.design_no === data.design ? 1 : 0);
});

  this.updateStockWithScanned(this.stockData, data, 'Add')
}

addnewShirtCode(){
  this.designPreview = [];
   $("#designpr").modal("show");
}
  createCode(event: any) {
   
    if(this.designPreview.length > 0){
      swal("ERROR", "One Barcode Will Scan at a time !!", "error")
      event.target.value = '';
      return
    }
    
    if (event.target.value.length == 7) {
      let params = {
        barcode: event.target.value,
        type : 'get'
      }
      let that = this;
      // that.barcodeDisabled = true;
      that.sampService.saveBarcodeDet(params).then((res: any) => {
        if (res.success && res.data) {
         that.designPreview.push({...res.data})

        }
      });
    }
  }

saveBarcodeDet(){
    let params = {
        barcode: this.designPreview[0].barcode,
        table_name: this.designPreview[0].table_name,
        type : 'addStock'
      }
      let that = this;

      that.sampService.saveBarcodeDet(params).then((res: any) => {
        if (res.success) {
          $("#designpr").modal("hide");
          that.shirtBarcodeInput.nativeElement.value = this.designPreview[0].barcode
          that.getNewopenStk();
          that.getBarcodeDetails('shirtBarcode', { target: { value: this.designPreview[0].barcode } })
        }
      });
}

  getNewopenStk() {


    this.totPcs = 0;
    this.stockData = [];

    let params = {
      design_no: this.filter.design_no,
    }
    //If Breaks the Invalid stock process in StockData Grid just add new barcodes in stock_total grid and maintain sc_tot as same...
    this.sampService.getDesignopenStk(params).then((res: any) => {

      if (res.needsReset) {
        return;
      }

      if (res.data && res.data.length > 0) {
        this.stockData = res.data;
        this.totPcs = this.stockData.reduce((sum, e) => sum + (Number(e.stk_tot) || 0), 0);

      }
      else if (!res.success) {
        swal("ERROR", `${res.message}`, "error")
      }

    });


  }
updateStockWithScanned(updatedStock, shirtDet, action) {
  // Helper: Map size like 'F36' or 'H38' to keys 'f36' or 'h38'
  const sizeToKey = (size) => size.toLowerCase();

  const designId = shirtDet.design_id;
  const sizeKey = sizeToKey(shirtDet.size); // e.g. 'f36' or 'h38'
  const qty = shirtDet.qty || 1;

  // Find stock record matching design_id
  const stockRecord = updatedStock.find(s => s.design_id === designId);
  if (!stockRecord) return updatedStock; // no match, just return original clone

  // Initialize scanned and pending if null
  if (stockRecord['sc_' + sizeKey] == null) stockRecord['sc_' + sizeKey] = 0;
  if (stockRecord['pend_' + sizeKey] == null) stockRecord['pend_' + sizeKey] = stockRecord['stk_' + sizeKey] || 0;

  // Update scanned qty based on action
  if (action === 'Add') {
    stockRecord['sc_' + sizeKey] += qty;
  } else if (action === 'Delete') {
    stockRecord['sc_' + sizeKey] -= qty;
    if (stockRecord['sc_' + sizeKey] < 0) stockRecord['sc_' + sizeKey] = 0; // avoid negative
  }

  // Update scanned totals
  stockRecord.sc_ftot = Object.keys(stockRecord)
    .filter(k => k.startsWith('sc_f') && k !== 'sc_ftot' && k !== 'sc_tot')
    .reduce((sum, k) => sum + (Number(stockRecord[k]) || 0), 0);

  stockRecord.sc_htot = Object.keys(stockRecord)
    .filter(k => k.startsWith('sc_h') && k !== 'sc_htot' && k !== 'sc_tot')
    .reduce((sum, k) => sum + (Number(stockRecord[k]) || 0), 0);

  stockRecord.sc_tot = stockRecord.sc_ftot + stockRecord.sc_htot;

  // Update pending values = stock - scanned
  stockRecord['pend_' + sizeKey] = (stockRecord['stk_' + sizeKey] || 0) - stockRecord['sc_' + sizeKey];
  stockRecord.pend_ftot = (stockRecord.stk_ftot || 0) - stockRecord.sc_ftot;
  stockRecord.pend_htot = (stockRecord.stk_htot || 0) - stockRecord.sc_htot;
  stockRecord.pend_tot = (stockRecord.stk_tot || 0) - stockRecord.sc_tot;


  return updatedStock;
}




  barcodeFocus(id: string) {

    setTimeout(() => {
      document.getElementById(id).focus();
    }, 300);
  }


  closeModel(){
         $("#materialpr").modal("hide");
  }

  resetDesignsList: any[] = [];
  submitConfirmBags: any[] = [];
  submitConfirmUnscanned: any[] = [];
  submitParams: any = {};

  openResetDesignsList() {
    this.sampService.getResetDesigns({}).then((res: any) => {
      this.resetDesignsList = res.success ? (res.data || []) : [];
      $("#resetDesignsModal").modal("show");
    }).catch(() => {
      this.resetDesignsList = [];
      $("#resetDesignsModal").modal("show");
    });
  }

  closeResetDesignsModal() {
    $("#resetDesignsModal").modal("hide");
  }

  revertResetDesign(designNo: string) {
    swal({
      title: 'Revert Reset?',
      text: `This will undo the reset for "${designNo}" and restore all pieces to their original completed state. Any draft scans for this design will be lost.`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Revert',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#d33',
    }).then(() => {
      this.sampService.revertOpeningStock({ design_no: designNo }).then((res: any) => {
        if (res.success) {
          swal('Reverted', res.message || `${designNo} has been reverted successfully.`, 'success');
          this.resetDesignsList = this.resetDesignsList.filter(d => d.design_no !== designNo);
        } else {
          swal('ERROR', res.message || 'Revert failed', 'error');
        }
      });
    }).catch(() => {});
  }


  deleteRow(flag: string, index: number) {

    //If delete the completed set Name Barcode, then delete all of remaining barcodes as well

    //Runnig set delete check 
    this.shirtBarcodeDetails
      .filter(e => e.bag_barcode === this.shirtBarcodeDetails[index].bag_barcode)
      .forEach(e => e.isBackground = true);
    // if (this.count >=1) {

    //For size/Damage Item
     if(!this.shirtBarcodeDetails[index].bag_barcode)
         this.shirtBarcodeDetails.forEach(e => e.isBackground = false);
      
    this.updateStockWithScanned(this.stockData, this.shirtBarcodeDetails[index], 'Delete')
    this.shirtBarcodeDetails.splice(index, 1);
    this.count = this.count >= 1 ? this.count - 1 : 0
     this.scannedDes_id =  this.count ? this.scannedDes_id : 0;
    // }

    this.checkSave();
    console.log(this.temp, this.count, this.stockData, this.hsetData)


  }

    calculateMaterials() {

    // Step 1: Combine setFull and setHalf by setName + set_per
    const combinedMap = new Map();

    [...this.setFull, ...this.setHalf].forEach(item => {
      const key = `${item.setName}__${item.set_per}`;
      if (!combinedMap.has(key)) {
        combinedMap.set(key, {
          setName: item.setName,
          set_per: item.set_per,
          count: 0
        });
      }
      combinedMap.get(key).count += item.setCount;
    });

    const combinedSets = Array.from(combinedMap.values());

    // Step 2: Initialize materialList with needed = 0
    const result = this.materialList.map(mat => ({
      ...mat,
      needed: 0
    }));

    // Step 3: For each set, find matching material by capacity == set_per
    combinedSets.forEach(set => {
      const matchingMaterial = result.find(m => m.capacity == set.set_per);
      if (matchingMaterial) {
        matchingMaterial.needed += set.count;
      }
    });

    // Final Output
    this.materialList = result.filter(m => m.needed > 0)

     $("#materialpr").modal("show");
  }

  addDStock(type) {

      let resGroup = [];
    if (type == 'Submit') {

      // First filter ONLY items that explicitly have is_new: "true"
    
      const newItems = this.shirtBarcodeDetails.filter(item => item.is_new === "true");

      // Then group by design_id and size
      const groupArr = newItems.reduce((acc, item) => {
        const existingGroup = acc.find(group =>
          group.design_id === item.design_id && group.size === item.size
        );

        if (existingGroup) {
          existingGroup.qty += item.qty || 0;
        } else {
          acc.push({
            design_id: item.design_id,
            is_new: item.is_new,
            size: item.size,
            qty: item.qty || 0
          });
        }

        return acc;
      }, []);

      // Final filter for qty >= 1 (though all should qualify since we filtered is_new)
      resGroup = groupArr.filter(item => item.qty >= 1);
   
    }

   // Group items by bag_id
    const bagGroups = this.shirtBarcodeDetails.reduce((acc, item) => {
        const bagId = item.bag_id;
        if (!acc[bagId]) {
            acc[bagId] = [];
        }
        acc[bagId].push(item);
        return acc;
    }, {});
    
    // Check each bag for different set_ids
    const bagsWithDifferentSetIds = [];
    
    // Use Object.keys instead of Object.entries for better compatibility
    const bagIds = Object.keys(bagGroups);
    
    for (let i = 0; i < bagIds.length; i++) {
        const bagId = bagIds[i];
        const items = bagGroups[bagId];
        
        // Get unique set_ids for this bag (compatible way without spread operator)
        const setIds = items.map(item => item.set_id);
        const uniqueSetIds = setIds.filter((value, index, self) => {
            return self.indexOf(value) === index;
        });
        
        // If there are multiple different set_ids in the same bag
        if (uniqueSetIds.length > 1) {
            bagsWithDifferentSetIds.push({
                bag_id: parseInt(bagId),
                bag_barcode: items[0].bag_barcode,
                set_ids: uniqueSetIds,
                items_count: items.length
            });
        }
    }
    



    if (bagsWithDifferentSetIds && bagsWithDifferentSetIds.length > 0) {
      swal("ERROR", `Bag-${bagsWithDifferentSetIds[0].bag_barcode} Contains Different Set Barcodes!!!`, "error");

      return false;
    }




    this.filter.date = this.datePipe.transform(this.filter.date, "yyyy-MM-dd");
    let that = this;
    let params: any = Object.assign({}, this.filter);
    params["tabevent"] = undefined;
    params["shirtDetails"] = JSON.stringify(this.shirtBarcodeDetails);
    params["saveType"] = type;
    params["stockData"] = type == 'Submit' ? JSON.stringify(this.stockData) : JSON.stringify([]);
    params['page_from'] = 'existsetBagging';
    params["combinedSet"] = JSON.stringify(this.combinedSet);
    params["sizeGroup"] = type == 'Submit' ? JSON.stringify(resGroup) : JSON.stringify([]);

    if (type == 'Submit') {
      // Build bags summary
      const bagMap: any = {};
      this.shirtBarcodeDetails.forEach(item => {
        if (item.bag_id) {
          if (!bagMap[item.bag_id]) {
            bagMap[item.bag_id] = { bag_barcode: item.bag_barcode, count: 0 };
          }
          bagMap[item.bag_id].count++;
        }
      });
      this.submitConfirmBags = Object.keys(bagMap).map(k => bagMap[k]);

      // Unscanned pieces per shade (pend_tot > 0 means not scanned yet)
      this.submitConfirmUnscanned = this.stockData.filter(s => (Number(s.pend_tot) || 0) > 0);

      this.submitParams = params;
      $("#submitConfirmModal").modal("show");
      return;
    }

    swal({
      title: "Are you sure to save this Draft?",
      type: "info",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.doSave(params);
    }).catch(() => {});

  }

  confirmSubmit() {
    $("#submitConfirmModal").modal("hide");
    this.doSave(this.submitParams);
  }

  doSave(params: any) {
    let that = this;
    that.sampService.addBaggingStock(params).then(function (res: any) {
      if (res.success) {
        that.toasterService.pop({
          bodyOutputType: 1,
          type: "success",
          title: "SUCCESS",
          body: "Bag No added successfully",
        });
        if (res.materialList && res.materialList.length > 0) {
          that.setFull = res.setFull;
          that.setHalf = res.setHalf;
          that.sizeList = res.sizeList;
          that.materialList = res.materialList;
          that.calculateMaterials();
        }
        that.filter = {};
        that.shirtBarcodeDetails = [];
        that.stockData = [];
        that.hsetData = [];
        that.combinedSet = [];
        that.onsaveDisable = true;
      } else {
        swal("ERROR", res.message, "error");
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/sample/AddEditExistSetbagging.ts